"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExperiment = void 0;
const react_1 = __importDefault(require("react"));
const CoreFeaturesContext_1 = require("./CoreFeaturesContext");
function useExperiment(experimentKey) {
    const context = react_1.default.useContext(CoreFeaturesContext_1.CoreFeaturesContext);
    if (context === undefined) {
        throw new Error('useExperiment must be used within a CoreFeaturesProvider');
    }
    const assignmentValue = context.getExperimentAssignment(experimentKey);
    return {
        isLoading: context.isLoading,
        assignment: assignmentValue,
    };
}
exports.useExperiment = useExperiment;
